module.exports = __webpack_public_path__ + "img/v.2bfa95f7.jpg";